/**
 * Helper to fetch with Clerk Auth token automatically.
 * @param {string} url 
 * @param {Object} options 
 * @param {Function} getToken Clerk's getToken function.
 */
export async function authFetch(url, options = {}, getToken) {
  const token = await getToken();
  
  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };

  const response = await fetch(url, { ...options, headers });
  
  if (response.status === 401) {
    // Handle session expiry or similar
    console.error("Auth Failure: Redirecting or refreshing session.");
  }
  
  return response;
}
